import { render, staticRenderFns } from "./assortView.vue?vue&type=template&id=713e8485&"
import script from "./assortView.vue?vue&type=script&lang=js&"
export * from "./assortView.vue?vue&type=script&lang=js&"
import style0 from "./assortView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports